import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import { formatApiErrorDetail } from "../lib/api";
import { Lock, ArrowLeft } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(email.trim(), password);
      toast.success("Welcome back, Dan.");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0D0D0D] grain relative flex items-center justify-center px-6">
      <Link
        to="/"
        data-testid="back-home-link"
        className="absolute top-6 left-6 flex items-center gap-2 text-xs tracking-[0.3em] uppercase text-white/60 hover:text-[#FF5A00]"
      >
        <ArrowLeft className="w-4 h-4" /> Back to site
      </Link>

      <div className="w-full max-w-md border border-[#333] bg-[#1A1A1A] relative z-10">
        <div className="border-b border-[#333] p-8 flex items-center gap-4">
          <div className="w-12 h-12 bg-[#FF5A00] flex items-center justify-center">
            <Lock className="w-6 h-6 text-black" />
          </div>
          <div>
            <div className="text-[10px] tracking-[0.3em] uppercase text-[#FF5A00] font-bold">
              TradesmanDan · Admin
            </div>
            <div className="font-heading text-3xl uppercase tracking-tight text-white mt-1">
              Sign In
            </div>
          </div>
        </div>
        <form onSubmit={submit} className="p-8 space-y-5">
          <div>
            <Label className="text-[10px] tracking-[0.3em] uppercase text-[#A3A3A3]">Username</Label>
            <Input
              data-testid="admin-email"
              autoFocus
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-2 bg-[#0D0D0D] border-[#333] rounded-none text-white focus:border-[#FF5A00]"
              placeholder="jmatthews"
            />
          </div>
          <div>
            <Label className="text-[10px] tracking-[0.3em] uppercase text-[#A3A3A3]">Password</Label>
            <Input
              data-testid="admin-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-2 bg-[#0D0D0D] border-[#333] rounded-none text-white focus:border-[#FF5A00]"
              placeholder="••••••••"
            />
          </div>
          <button
            data-testid="admin-login-submit"
            type="submit"
            disabled={submitting}
            className="w-full bg-[#FF5A00] text-black font-heading tracking-[0.2em] uppercase py-4 hover:bg-[#E65100] transition-colors disabled:opacity-60"
          >
            {submitting ? "Signing in…" : "Sign In →"}
          </button>
        </form>
      </div>
    </div>
  );
}
